import omit from 'lodash-es/omit'
import pick from 'lodash-es/pick'

import { DOC_FLOW_MAPPING_RESULT_TABLE_TOGGLE_FILTER_NAMES } from '../DocFlowMappingResultTable'

function isDocFlowMappingResultTableToggleFilter({ name }) {
  return DOC_FLOW_MAPPING_RESULT_TABLE_TOGGLE_FILTER_NAMES.includes(name)
}

export function getDocFlowMappingResultTableToggleFilters(availableFilters) {
  return availableFilters.filter(isDocFlowMappingResultTableToggleFilter)
}

export function getDocFlowMappingResultTableBarFilters(availableFilters) {
  return availableFilters.filter(
    filter => !isDocFlowMappingResultTableToggleFilter(filter)
  )
}

export function getDocFlowMappingResultTableToggleFilterValues({
  filterValues,
  isOn,
  name,
}) {
  const restFilterValues = omit(
    filterValues,
    DOC_FLOW_MAPPING_RESULT_TABLE_TOGGLE_FILTER_NAMES
  )

  return isOn ? { ...restFilterValues, [name]: true } : restFilterValues
}

export function getDocFlowMappingResultTableTogglePermanentFilters({
  filterValues,
}) {
  return pick(filterValues, DOC_FLOW_MAPPING_RESULT_TABLE_TOGGLE_FILTER_NAMES)
}
